// ─────────────────────────────────────────────────────────────
// TOAST NOTIFICATIONS
//
// Tiny pub/sub system for showing transient notifications.
// Usage anywhere in the app:
//
//   import { toast } from "./lib/toast";
//   toast.success("Trade saved");
//   toast.error("Couldn't connect to server");
//   toast.info("Importing 12 of 50…");
//
// The <ToastContainer /> in App.js subscribes and renders.
// ─────────────────────────────────────────────────────────────

const listeners = new Set();
let nextId = 1;

function emit(type, message, opts = {}) {
  const id = nextId++;
  const toast = {
    id,
    type,         // "success" | "error" | "info"
    message,
    duration: opts.duration ?? (type === "error" ? 5000 : 3000),
  };
  listeners.forEach(fn => fn({ kind: "add", toast }));
  return id;
}

function dismiss(id) {
  listeners.forEach(fn => fn({ kind: "remove", id }));
}

export const toast = {
  success: (message, opts) => emit("success", message, opts),
  error:   (message, opts) => emit("error",   message, opts),
  info:    (message, opts) => emit("info",    message, opts),
  dismiss,
};

// Used by ToastContainer to subscribe to events
export function subscribeToasts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
